import React, { createContext, useContext, useMemo, useState } from 'react';

const UIContext = createContext(null);

export const UIProvider = ({ children }) => {
  const [background, setBackground] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [loginOpen, setLoginOpen] = useState(false);
  const [newUserProfileSetup, setNewUserProfileSetup] = useState(false);

  const value = useMemo(() => ({
    background,
    setBackground,
    selectedLocation,
    setSelectedLocation,
    loginOpen,
    setLoginOpen,
    newUserProfileSetup,
    setNewUserProfileSetup,
  }), [
    background,
    selectedLocation,
    loginOpen,
    newUserProfileSetup,
  ]);

  return (
    <UIContext.Provider value={value}>
      {children}
    </UIContext.Provider>
  );
};

export const useUI = () => {
  const context = useContext(UIContext);
  if (!context) {
    throw new Error('useUI must be used within UIProvider');
  }
  return context;
};

export default UIContext;
